module.exports = function(object) {
    return Object.keys(object).length === 0;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-inspector/lib/is-empty.js
 ** module id = 148
 ** module chunks = 0
 **/